import { EmbeddedMessage } from 'constants/messageMediums';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { usePlacementSelectorContext } from 'modules/placements/context/PlacementSelectorContext';
import { TemplateDetailsBlock } from './EditableHeader.styled';

export const SubHeaderPlacement = () => {
  const { medium } = useTemplateQueryContext();
  const isEmbedded = medium === EmbeddedMessage;
  const { selectedPlacementDetails } = usePlacementSelectorContext();

  return isEmbedded && selectedPlacementDetails ? (
    <TemplateDetailsBlock>{`${selectedPlacementDetails.placementName}`}</TemplateDetailsBlock>
  ) : null;
};
